import {
    getSubscriptionItem,
    listSubscriptionItems
} from './queries';
import {
    createSubscriptionItem,
    deleteSubscriptionItem,
    updateSubscriptionItem,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {SubscriptionItem} from "../types.ts";
import {generateClient} from "aws-amplify/api";


export type ListSubscriptionItems = {
    listSubscriptionItems: { items: SubscriptionItem[], nextToken?: string }
}

export type GetSubscriptionItem = {
    getSubscriptionItem: SubscriptionItem
}

export type CreateSubscriptionItem = {
    createSubscriptionItem: SubscriptionItem
}

export type UpdateSubscriptionItem = {
    updateSubscriptionItem: SubscriptionItem
}

export type DeleteSubscriptionItem = {
    deleteSubscriptionItem: string
}


const client = generateClient();

export const fetchRecords = async (customerId: string, limit?: number, nextToken?: string) => {

    const response = await client.graphql<GraphQLQuery<ListSubscriptionItems>>({
                                                                                   query: listSubscriptionItems,
                                                                                   variables: {customerId: customerId, limit, nextToken},
                                                                               });
    return response.data?.listSubscriptionItems;
};

export const fetch = async (customerId: string, id: string) => {
    const response = await client.graphql<GraphQLQuery<GetSubscriptionItem>>({
                                                                                 query: getSubscriptionItem,
                                                                                 variables: {
                                                                                     customerId: customerId,
                                                                                     id: id
                                                                                 },
                                                                             });
    return response.data?.getSubscriptionItem;
};

export const add = async (payload: object) => {

    const response = await client.graphql<GraphQLQuery<CreateSubscriptionItem>>({
                                                                                    query: createSubscriptionItem,
                                                                                    variables: {
                                                                                        input: payload
                                                                                    },
                                                                                });

    return response.data?.createSubscriptionItem;
};

export const update = async (record: SubscriptionItem) => {

    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateSubscriptionItem>>({
                                                                                    query: (updateSubscriptionItem),
                                                                                    variables: {input: record},
                                                                                });
    return response.data?.updateSubscriptionItem;
};

export const deleteRecord = async (customerId: string, id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteSubscriptionItem>>({
                                                                                    query: (deleteSubscriptionItem),
                                                                                    variables: {
                                                                                        input: {
                                                                                            customerId: customerId,
                                                                                            id: id
                                                                                        }
                                                                                    },

                                                                                });
    return response.data?.deleteSubscriptionItem;
};
